import _ from 'lodash';
import sanitizeContent from '../services/sanitize-content';

export const UPDATE_POST_REQUEST = 'post/UPDATE_REQUEST';
export const UPDATE_POST_SUCCESS = 'post/UPDATE_SUCCESS';
export const UPDATE_POST_FAILURE = 'post/UPDATE_FAILURE';

const PROPS = ['title', 'content'];

export function updatePost(post = {}) {
  return (dispatch, getState, { request }) => {
    dispatch({
      type: UPDATE_POST_REQUEST,
    });

    const promise = request.patch(`/_api/posts/${post._id}`, sanitizeContent(_.pick(post, PROPS)));

    return promise
      .then(updatedPost =>
        dispatch({
          type: UPDATE_POST_SUCCESS,
          payload: updatedPost,
        })
      )
      .catch(() =>
        dispatch({
          type: UPDATE_POST_FAILURE,
        })
      )
      .then(() => promise);
  };
}



// WEBPACK FOOTER //
// ./app/actions/update-post.js